var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('notifications',{attrs:{"position":"bottom right"}}),_c('user-need-update-modal',{attrs:{"id":"user-notification-modal"}}),(_vm.hasAccessToNavigation)?[_c('TopHeader'),_c('Navigation')]:_vm._e(),_c('router-view',{key:_vm.routerKey})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }